import dayjs from 'dayjs';

export const DaysOfWeek = [
  { label: 'Monday', prefix: 'Mon' },
  { label: 'Tuesday', prefix: 'Tue' },
  { label: 'Wednesday', prefix: 'Wed' },
  { label: 'Thursday', prefix: 'Thu' },
  { label: 'Friday', prefix: 'Fri' },
  { label: 'Saturday', prefix: 'Sat' },
  { label: 'Sunday', prefix: 'Sun' },
];

const startOfWeek = dayjs().startOf('week'); // Start of the current week
const endOfWeek = dayjs().endOf('week'); // End of the current week

export const TimeSlots = [
  {
    label: '☀️ Morning',
    prefix: 'Morning',
    startTime: startOfWeek.hour(6).toISOString(), // Start time for Morning
    endTime: startOfWeek.hour(11).minute(59).toISOString(), // End time for Morning
  },
  {
    label: '☁️ Afternoon',
    prefix: 'Afternoon',
    startTime: startOfWeek.hour(12).toISOString(), // Start time for Afternoon
    endTime: startOfWeek.hour(16).minute(59).toISOString(), // End time for Afternoon
  },
  {
    label: '🌒 Evenings',
    prefix: 'Evening',
    startTime: startOfWeek.hour(17).toISOString(), // Start time for Evening
    endTime: startOfWeek.hour(21).minute(59).toISOString(), // End time for Evening (next day)
  },
  {
    label: '🌑 Late Night',
    prefix: 'Late Night',
    startTime: startOfWeek.hour(22).toISOString(), // Start time for Late Night (next day)
    endTime: endOfWeek.add(1, 'day').hour(2).toISOString(), // End time for Late Night
  },
];
